/**
 * Auto-generated API Client
 *
 * Generated by @spfn/core codegen
 * DO NOT EDIT MANUALLY
 *
 * @generated 2025-11-03T13:40:07.039Z
 */

import { client } from '@spfn/core/client';
import type { InferContract } from '@spfn/core';

import { saveValuesContract, getValuesContract } from '@/lib/contracts/values';

// ============================================
// Types
// ============================================

export type SaveValuesResponse = InferContract<typeof saveValuesContract>['response'];
export type SaveValuesParams = InferContract<typeof saveValuesContract>['params'];
export type SaveValuesBody = InferContract<typeof saveValuesContract>['body'];

export type GetValuesResponse = InferContract<typeof getValuesContract>['response'];
export type GetValuesQuery = InferContract<typeof getValuesContract>['query'];
export type GetValuesParams = InferContract<typeof getValuesContract>['params'];

// ============================================
// API Functions
// ============================================

/**
 * POST /_cms/values/:labelId
 */
export const saveValues = (options: { params: SaveValuesParams, body: SaveValuesBody }) => client.call(saveValuesContract, options);

/**
 * GET /_cms/values/:labelId/:version
 */
export const getValues = (options: { params: GetValuesParams, query?: GetValuesQuery }) => client.call(getValuesContract, options);

